// twitterBot.js
var TwitterBot = pc.createScript('TwitterBot');

TwitterBot.attributes.add('mainURL', {type:'string'});
TwitterBot.attributes.add('exportInfo', {type:'boolean', default:false});

// initialize code called once per entity
TwitterBot.prototype.initialize = function(){
    this.app.on('screenShotter:ready', this.upload, this);
    this.app.on('solarSystem:allPlanets', this.setPlanet, this);
    this.planetTag = this.app.root.findByName('planetNumberTag');
    this.planetInfo = this.app.root.findByName('planetInfo');
    this.twitterButton = this.app.root.findByName('twitter');
    this.twitterLoading = this.twitterButton.children[0];
    this.twitterLoading.enabled = false;
    this.urlParams = null;
    this.planetList = [];
    //console.info(this.twitterButton.element);
    this.inptBtn = this.app.root.findByName('inputField');
    this.userInputScript = this.app.root.children[0].script.userInputHandler;

    //console.info(this.twitterLoading);
    //console.info(this.twitterButton);
    
    this.cta = ['VISIT', 'DISCOVER', 'FLY TO', 'EXPLORE', 'ENJOY', 'TRAVEL TO', 'COME TO',
               'WARP TO', 'EXPERIENCE', 'TAKE A TRIP TO', 'VACCATION AT', ''];
};

// https://twt.rtz23robot.de:3000/api/image    http://localhost:3000/api/image

TwitterBot.prototype.setPlanet = function(plnts,sys){
    //console.log('SETPLANETS');
    this.planetList = plnts;
};


TwitterBot.prototype.upload = function(file) {

    this.twitterButton.button.active = false;
    this.twitterButton.element.opacity = 0.1;
    this.twitterLoading.enabled = true;
    
    this.theSeed = this.inptBtn.script.input.getValue();
    this.thePlanet = this.userInputScript.currentPlanet;
    //console.info(this.thePlanet);
    //console.info(this.planetList);
    for(var i = 0; i < this.planetList.length; i++){
        if(this.thePlanet.name == 'system'){
            this.urlParams = '?s=' + this.theSeed;
        } else if(this.thePlanet === this.planetList[i]) {
            this.urlParams = '?s=' + this.theSeed + '&p=' + (i+1);
        }
       // console.log('tp: ' + this.thePlanet.name + this.planetList[i].name);
    }
    
    //console.log('theSeed: ' + this.theSeed);
    //console.log('thePlanet: ' + this.thePlanet.name);
    
    var that = this;
    var cnvs = document.getElementById('application-canvas');
    var myimg = cnvs.toDataURL('application/octet-stream').split(',')[1];
    var planetName = this.planetTag.element.text.replace('NAME:\n', '');
    var planetInfo = this.planetInfo.element.text;
    var theLink = this.mainURL + this.urlParams;
    var myText = this.cta[Math.floor(Math.random()*this.cta.length)] + ' ' + planetName + '\n\n' + planetInfo.toLowerCase() + ' \n' + theLink + '\n ' + '#nfts #space #pocketverse '; // #nfts #space #pocketverse
    
    if(this.exportInfo){
        console.log(planetName);
        console.log(planetInfo);
       // this.exportInfo = false;
        this.cooldown(25);
        return;
    } else {

   // console.log('xhrRequest to rtz23robot');
   //console.log(myimg);
	var xhr = pc.http.post('https://twt.rtz23robot.de:3000/api/image', {'image':myimg, 'myText':myText}, {
	'Content-Type': 'arraybuffer',
	responseType: "text"
	}, function (err, response) {
        if(err){
            console.log('ERR');
            that.cooldown(25);
            return;
        }
	   // console.log(response.id);
	   //console.info(response);
       that.retweet(response.id_str);
       // console.log('response from rtz23 robot: ' + response.id_str);
	});    
        
    }
};    

TwitterBot.prototype.retweet = function(theID){
    //this.twitterButton.button.active = true;
    //this.twitterButton.element.enabled = true;
    //this.twitterButton.element.opacity = 0.5;
  //  console.log('retweeting ' + theID);
    this.twitterLoading.enabled = false;
   // console.log('RETWEET');
    window.open('https://twitter.com/intent/retweet?tweet_id=' + theID);
    this.cooldown(30000);
};

TwitterBot.prototype.cooldown = function(cd){
    var that = this;
    this.twitterButton.children[0].enabled = false;
    this.twitterButton.children[1].enabled = true;
    
    setTimeout(function(){
        that.twitterButton.button.active = true;
        that.twitterButton.element.enabled = true;
        that.twitterButton.element.opacity = 0.5;
        that.twitterButton.children[1].enabled = false;
    },cd);    
};



//https://twt.rtz23robot.de/46


// swap method called for script hot-reloading
// inherit your script state here
// TwitterBot.prototype.swap = function(old) { };

// to learn more about script anatomy, please read:
// https://developer.playcanvas.com/en/user-manual/scripting/

